import React, { Component, lazy, Suspense } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Switch, Route, Redirect } from 'react-router-dom'
import { getServerDate, validateToken, login } from './store/ducks/auth'
import Layout from './components/HorizontalLayout'
import logo from './assets/images/logo-light.png'
import logoMin from './assets/images/logo192.png'
import Dashboard from './pages/Dashboard'
import DashboardErp from './pages/DashboardErp'
import TesteOneDrive from './components/TesteOneDrive/TesteOneDrive'
import FinishExpedient from './pages/HumanResources/FinishExpedient'
import RegistrarAtividadesRetroativas from './pages/HumanResources/RegistrarAtividadesRetroativas'
import ActivitiesReport from './pages/HumanResources/ActivitiesReport'
import VacationRequest from './pages/HumanResources/VacationRequest'
import RegisterAbsence from './pages/HumanResources/RegisterAbsence'
import RetroactiveExpedient from './pages/HumanResources/RetroactiveExpedient'
import RhDashboard from './pages/HumanResources/Dashboard'
import FichaPj from './pages/HumanResources/FichaPj'
import RhFichaPjList from './pages/HumanResources/FichaPj/RhFichaPjList'
import GestaoVagas from './pages/HumanResources/GestaoVagas'
import Projects from './pages/TechnicalDep/Projects'
import Portifolio from './pages/TechnicalDep/Portifolio de Projetos'
import Project from './pages/TechnicalDep/Project'
import Products from './pages/TechnicalDep/Products'
import DashboardEntregas from './pages/TechnicalDep/DashboardEntregas'
import Atividades from './pages/TechnicalDep/Atividades'
import GestaoAtividades from './pages/TechnicalDep/GestaoAtividades'
import Payments from './pages/TechnicalDep/Payments'
import MyTasks from './pages/Tasks/MyTasks'
import WalletResume from './pages/Wallet/Resume'
import ApprovalResume from './pages/Approval/Resume'
import PendingSolicitations from './pages/Management/PendingSolicitations'
import ReplySolicitation from './pages/Management/ReplySolicitation'
import LegalSolicitations from './pages/Management/LegalSolicitations'
import OfficialLetters from './pages/Management/OfficialLetters'
import MySolicitations from './pages/User/MySolicitations'
import ReplyMySolicitation from './pages/User/ReplySolicitation'
import UserAgenda from './pages/Agenda/UserAgenda'
import NewFeedback from './pages/Feedback/NewFeedback'
import MeusFornecedores from './pages/MeusFornecedores/index'
import PrefRibSig from './pages/TechnicalDep/Project/prefribeiraopreto/sig'
// eslint-disable-next-line no-unused-vars
import CustomerIndex from './pages/Customer'
import TiSolicitations from './pages/Patrimony/TiSolicitations'
import AssetPurchaseAndMaintenance from './pages/Patrimony/AssetPurchaseAndMaintenance'
import Contracts from './pages/Comercial/Contracts'
import Acompanhamento from './pages/Comercial/Acompanhamento/Acompanhamento'
import NovaPropostaEmBranco from './pages/Comercial/Acompanhamento/NovaPropostaEmBranco'
import RevisarOrcamento from './pages/Comercial/Acompanhamento/RevisarOrcamento'
import RevisarEscopoOrcamento from './pages/Comercial/Acompanhamento/RevisarEscopoOrcamento'
import NovaPropostaModeloProposta from './pages/Comercial/Acompanhamento/NovaPropostaModeloProposta'
import NovaPropostaModeloCliente from './pages/Comercial/Acompanhamento/NovaPropostaModeloCliente'
import Contract from './pages/Comercial/Contracts/Contract'
import Private from './pages/Comercial/Private'
import Proposal from './pages/Comercial/Private/Proposal'
import Public from './pages/Comercial/Public'
import DraftContract from './pages/Comercial/Contracts/DraftContract'
import Admin from './pages/Admin'
import DocumentosRepositorio from './pages/DocumentosRepositorio'
import Profile from './pages/User/Profile'
import DashboardFinancial from './pages/Financial'
import BudgetDashboard from './pages/Budget/Dashboard'
import Orcamento from './pages/Financial/Orcamento'
import Bordero from './pages/Financial/Bordero'
import Blockchain from './pages/Blockchain/Blockchain'
import Receitas from './pages/Financial/Receitas'
import Contratacoes from './pages/Financial/Contratacoes'
import Task from './pages/Task'
import TestPage from './pages/TestPage'
import './theme.scss'
import { Container } from 'reactstrap'
import PesquisaDeSatisfacao from './pages/Comercial/PesquisaDeSatisfacao/PesquisaDeSatisfacao'
import Atestados from './pages/Atestados/Atestados'
import VincularCases from './pages/Marketing/VincularCases'
import VincularAtestados from './pages/Marketing/VincularAtestados'
import Orcamentacao from './pages/Orcamentacao/Orcamentacao'
import DevWeeklyBoard from './pages/DevBoard/DevWeeklyBoard'
import GestaoMinutas from './pages/GestaoMinutas'
import UiPlayground from './pages/UiPlayground'
import ErpDesignCatalog from './pages/ErpDesignCatalog'
import RegistroTelas from './pages/RegistroTelas'
import AtendimentoOikos from './pages/AtendimentoOikos'
import FichaCadastral from './pages/HumanResources/FichaCadastral'

const TeamsTranscripts = lazy(() => import('./pages/TeamsTranscripts'))

class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      firstTime: true,
    }
  }

  componentDidMount() {
    const {
      getServerDate, validateToken,
    } = this.props

    document.body.setAttribute('data-layout', 'horizontal')
    document.body.setAttribute('data-topbar', 'dark')
    document.body.removeAttribute('data-sidebar')
    document.body.removeAttribute('data-sidebar-size')
    document.body.setAttribute('data-layout-size', 'boxed')

    getServerDate()
    validateToken()
  }

  handleFirstTime = () => {
    this.setState(prevState => ({ firstTime: !prevState.firstTime }))
  }

  render() {
    const {
      login, getServerDate,
    } = this.props
    const {
      getServerDateIsLoading, getServerDateError,
      validationIsLoading, user, validToken,
    } = this.props.auth

    if (getServerDateIsLoading || validationIsLoading) {
      return (
        <div
          style={{
            backgroundColor: '#fff',
            height: '100vh',
            width: '100vw',
          }}
        >
          <div className="centered">
            <img src={logoMin} width={64} height={64} alt="Logo Ecossis SoluÃ§Ãµes Ambientais" />
          </div>
        </div>
      )
    }

    if (getServerDateError) {
      return (
        <div
          style={{
            backgroundColor: '#fff',
            height: '100vh',
            width: '100vw',
          }}
        >
          <div
            className="centered"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <img src={logoMin} width={64} height={64} alt="Logo Ecossis SoluÃ§Ãµes Ambientais" />
            <span style={{
              color: 'red',
              marginTop: 16,
              marginBottom: 16,
            }}
            >{getServerDateError}
            </span>
            <button className="login-btn" type="button" onClick={() => getServerDate()}>
              Tentar novamente
            </button>
          </div>
        </div>
      )
    }

    if (!user || !validToken) {
      const loginPage = () => (
        <div className="login-page">
          <div
            className="centered"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <img src={logo} width={212} height={46} alt="Logo Ecossis SoluÃ§Ãµes Ambientais" />
            <div style={{ marginTop: 32 }}>
              <button className="login-btn" type="button" onClick={() => login()}>
                Entrar
              </button>
            </div>
          </div>
        </div>
      )

      return (
        <Switch>
          <Route exact path="/recursos-humanos/ficha-cadastral" component={FichaCadastral} />
          <Route exact path="/ficha-cadastral" component={FichaCadastral} />
          <Route
            exact
            path="/erp-design-catalog"
            render={() => <ErpDesignCatalog standalone mapSource="static" />}
          />
          <Route exact path="/recursos-humanos/ficha-pj" component={loginPage} />
          <Route>
            <Layout>
              <Switch>
                <Route exact path="/cliente/projeto/:id" component={CustomerIndex} />
                <Route exact path="/" component={loginPage} />
                <Route path="/login" component={loginPage} />
                <Redirect from="*" to="/login" />
              </Switch>
            </Layout>
          </Route>
          {console.log(validToken, user)}
        </Switch>
      )
    }

    if (user && validToken) {

      return (
        <Switch>
          <Route exact path="/recursos-humanos/ficha-cadastral" component={FichaCadastral} />
          <Route exact path="/ficha-cadastral" component={FichaCadastral} />
          <Route exact path="/recursos-humanos/ficha-pj" component={FichaPj} />
          <Route
            exact
            path="/erp-design-catalog"
            render={() => <ErpDesignCatalog standalone mapSource="api" />}
          />
          <Route>
            <Layout>
              <Switch>
            <Route exact path="/dashboard">
              <Dashboard firstTime={this.state.firstTime} handleFirstTime={this.handleFirstTime} />
            </Route>
            <Route exact path="/dashboard-erp" component={DashboardErp} />

            <Route exact path="/agenda" component={UserAgenda} />
            <Route exact path="/meusfornecedores" render={() => (<Container fluid style={{ paddingTop: '200px' }}><MeusFornecedores /></Container>)} />

            <Route exact path="/perfil" component={Profile} />
            <Route exact path="/colaborador/solicitacoes" component={MySolicitations} />
            <Route exact path="/colaborador/solicitacoes/:id" component={ReplyMySolicitation} />

            <Route exact path="/recursos-humanos/dashboard" component={RhDashboard} />
            <Route exact path="/recursos-humanos/dashboard/fichas-pj" component={RhFichaPjList} />
            <Route exact path="/recursos-humanos/encerrar-expediente" component={FinishExpedient} />
            <Route exact path="/recursos-humanos/registrar-atividades-retroativas" component={RegistrarAtividadesRetroativas} />
            <Redirect exact from="/recursos-humanos/encerrar-expediente-novo" to="/recursos-humanos/registrar-atividades-retroativas" />
            <Route exact path="/recursos-humanos/relatorio-de-atividades" component={ActivitiesReport} />
            <Route exact path="/recursos-humanos/solicitacao-de-ferias" component={VacationRequest} />
            <Route exact path="/recursos-humanos/justificativa-de-ausencia" component={RegisterAbsence} />
            <Route exact path="/recursos-humanos/ponto-retroativo" component={RetroactiveExpedient} />
            <Route exact path="/recursos-humanos/fichas-pj" component={RhFichaPjList} />
            <Route exact path="/rh-gestao-vagas" component={GestaoVagas} />

            <Route exact path="/patrimonio/aquisicao-e-manutencao" component={AssetPurchaseAndMaintenance} />
            <Route exact path="/patrimonio/chamados-de-ti" component={TiSolicitations} />

            <Route exact path="/dep-tecnico/projetos" component={Projects} />
            <Route exact path="/dep-tecnico/portifolio-de-projetos" component={Portifolio} />
            <Route exact path="/dep-tecnico/produtos" component={Products} />
            <Route exact path="/dep-tecnico/atividades" component={Atividades} />
            <Route exact path="/dep-tecnico/gestao-atividades" component={GestaoAtividades} />
            <Route exact path="/dep-tecnico/dashboard-entregas" component={DashboardEntregas} />
            <Route exact path="/dep-tecnico/projetos/:id" component={Project} />
            <Route exact path="/dep-tecnico/projetos/prefribeiraopreto/sig" component={PrefRibSig} />
            <Route exact path="/dep-tecnico/solicitacao-pagamento" component={Payments} />
            <Redirect from="/dep-tecnico/projetos/:id" to="/dep-tecnico/projetos" />

            <Route exact path="/tarefas" component={MyTasks} />

            <Route exact path="/carteira" component={WalletResume} />
            <Route exact path="/testecriapasta" component={TesteOneDrive} />

            <Route exact path="/aprovacoes" component={ApprovalResume} />

            <Route exact path="/gerencia/solicitacoes" component={PendingSolicitations} />
            <Route exact path="/gerencia/solicitacoes/:id" component={ReplySolicitation} />
            <Route exact path="/gerencia/atestados" render={() => (<Container fluid style={{paddingTop: '200px'}}><Atestados/></Container>)} />
            <Route exact path="/gerencia/vincular-cases" render={() => (<Container fluid style={{paddingTop: '200px'}}><VincularCases/></Container>)} />
            <Route exact path="/gerencia/vincular-atestados" render={() => (<Container fluid style={{paddingTop: '200px'}}><VincularAtestados/></Container>)} />
            <Route exact path="/gerencia/solicitacao-juridica" component={LegalSolicitations} />
            <Route exact path="/gerencia/oficios" component={OfficialLetters} />


            <Route exact path="/comercial/contratos/minuta/:id" component={DraftContract} />
            <Route exact path="/comercial/contratos" component={Contracts} />
            <Route exact path="/comercial/pesquisadesatisfacao" component={PesquisaDeSatisfacao} />
            <Route exact path="/comercial/contratos/:id" component={Contract} />
            <Route exact path="/comercial/orcamentacao" component={Orcamentacao} />

            <Route exact path="/comercial/acompanhamento" component={Acompanhamento} />
            <Route exact path="/comercial/acompanhamento/nova-proposta-em-branco/:id" component={NovaPropostaEmBranco} />
            <Route exact path="/comercial/acompanhamento/nova-proposta-modelo-cliente/:id" component={NovaPropostaModeloCliente} />
            <Route exact path="/comercial/acompanhamento/nova-proposta-modelo-proposta/:id" component={NovaPropostaModeloProposta} />
            <Route exact path="/comercial/acompanhamento/revisar-escopo-orcamento/:id" component={RevisarEscopoOrcamento} />
            <Route exact path="/comercial/acompanhamento/revisar-orcamento/:id" component={RevisarOrcamento} />

            <Route exact path="/comercial/privado" component={Private} />
            <Route exact path="/comercial/privado/propostas/:id" component={Proposal} />

            <Route exact path="/dashboardfinancial" component={DashboardFinancial} />
            <Route exact path="/financeiro/orcamento-dashboard" component={BudgetDashboard} />
            <Route exact path="/orcamento" component={Orcamento} />

            <Route exact path="/devboard" component={DevWeeklyBoard} />

            <Route exact path="/gestao-de-minutas" component={GestaoMinutas} />
            <Route
              exact
              path="/minhas-transcricoes"
              render={() => (
                <Suspense fallback={<Container fluid style={{ paddingTop: 120 }}>Carregando…</Container>}>
                  <TeamsTranscripts />
                </Suspense>
              )}
            />

            {}
            <Route exact path="/bordero" component={Bordero} />

            <Route exact path="/receitas" component={Receitas} />

            <Route exact path="/comercial/publico" component={Public} />

            <Route exact path="/contratacoes" component={Contratacoes} />

            <Route exact path="/feedback/novo" component={NewFeedback} />

            <Route exact path="/admin" component={Admin} />
            <Route exact path="/documentos" component={DocumentosRepositorio} />

            <Route exact path="/cliente/projeto/:id" component={CustomerIndex} />

            <Route exact path="/blockchain" component={Blockchain} />

            <Route exact path="/task" component={Task} />

            <Route exact path="/teste" component={TestPage} />

            <Route exact path="/ui-playground" component={UiPlayground} />
            <Route exact path="/registro-telas" component={RegistroTelas} />
            <Route exact path="/atendimento" component={AtendimentoOikos} />

            <Redirect from="*" to="/dashboard" />
              </Switch>
            </Layout>
          </Route>
        </Switch>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ auth: state.auth })
const mapDispatchToProps = dispatch => bindActionCreators({
  getServerDate,
  validateToken,
  login,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(App)